/* Official Front Uni RDC logo — transparent PNG */
export default function Logo({ className = "w-10 h-10", alt = "Front Uni pour la RDC" }) {
  return <img src="/logo.png" alt={alt} className={className} loading="eager" />;
}
